import React, { ReactElement, useState } from "react";
import Button from "../../Common/Buttons";
import { Flex } from "../../Common/Flex";
import Icon from "../../Common/Icon";
import FullScreenOverlay, {
    type BucketProps,
} from "../../Common/Overlay/FullScreenOverlay";
import ModalOverlay from "../../Common/Overlay/ModalOverlay";
import { Block } from "../LibraryBuildingBlocks";

type ExampleBucketProps = {
    title: string;
} & BucketProps;

function ExampleBucket(props: ExampleBucketProps) {
    const { title, size, minimize, maximize } = props;

    return size === "maximized" ? (
        <div style={{ padding: 12 }}>
            <Flex.Column gap="medium">
                <Button.Ghost
                    onClick={() => {
                        minimize();
                    }}
                >
                    <Icon.Close.Medium.N10 />
                </Button.Ghost>
                {title}
                <p>I am now in maximized mode</p>
                <p>Oh yes</p>
                <p>I am</p>
            </Flex.Column>
        </div>
    ) : (
        <Flex.Column
            gap="medium"
            onClick={() => {
                maximize();
            }}
        >
            <div style={{ padding: 12 }}>
                {title}
                <p>I am now in minimized mode</p>
            </div>
        </Flex.Column>
    );
}

export default function OverlayExamples() {
    const [state, setState] = useState({
        showModal: false,
        showFullScreen: false,
        showFullScreenWithBucket: false,
    });

    return (
        <>
            <Block title="Overlay">
                <Button.Primary
                    label="Open modal overlay"
                    onClick={() => {
                        setState({
                            showModal: true,
                            showFullScreen: false,
                            showFullScreenWithBucket: false,
                        });
                    }}
                />

                <Button.Primary
                    label="Open fullscreen overlay"
                    onClick={() => {
                        setState({
                            showModal: false,
                            showFullScreen: true,
                            showFullScreenWithBucket: false,
                        });
                    }}
                />

                <Button.Primary
                    label="Open fullscreen overlay with bucket"
                    onClick={() => {
                        setState({
                            showModal: false,
                            showFullScreen: false,
                            showFullScreenWithBucket: true,
                        });
                    }}
                />
            </Block>

            {state.showModal && (
                <ModalOverlay.Base
                    title="This title can also be span element"
                    onClose={() => {
                        setState({
                            showModal: false,
                            showFullScreen: false,
                            showFullScreenWithBucket: false,
                        });
                    }}
                >
                    <ModalOverlay.Content>
                        <Flex.Column gap="large">
                            <Flex.Row>This is some scrollable content</Flex.Row>
                            <Flex.Row>This is some scrollable content</Flex.Row>
                            <Flex.Row>This is some scrollable content</Flex.Row>
                            <Flex.Row>This is some scrollable content</Flex.Row>
                            <Flex.Row>This is some scrollable content</Flex.Row>
                            <Flex.Row>This is some scrollable content</Flex.Row>
                            <Flex.Row>This is some scrollable content</Flex.Row>
                            <Flex.Row>This is some scrollable content</Flex.Row>
                            <Flex.Row>This is some scrollable content</Flex.Row>
                            <Flex.Row>This is some scrollable content</Flex.Row>
                            <Flex.Row>This is some scrollable content</Flex.Row>
                            <Flex.Row>This is some scrollable content</Flex.Row>
                            <Flex.Row>This is some scrollable content</Flex.Row>
                            <Flex.Row>This is some scrollable content</Flex.Row>
                            <Flex.Row>This is some scrollable content</Flex.Row>
                            <Flex.Row>This is some scrollable content</Flex.Row>
                            <Flex.Row>This is some scrollable content</Flex.Row>
                        </Flex.Column>
                    </ModalOverlay.Content>

                    <ModalOverlay.Footer>
                        <Flex.Row>
                            <Button.Primary
                                label="Close"
                                onClick={() => {
                                    setState({
                                        showModal: false,
                                        showFullScreen: false,
                                        showFullScreenWithBucket: false,
                                    });
                                }}
                            />
                        </Flex.Row>
                    </ModalOverlay.Footer>
                </ModalOverlay.Base>
            )}

            {state.showFullScreen && (
                <FullScreenOverlay>
                    <Flex.Column gap="large">
                        <h3>
                            This overlay is only a container so layout ís decided by
                            child components.
                        </h3>
                        <Button.Primary
                            label="Close"
                            onClick={() => {
                                setState({
                                    showModal: false,
                                    showFullScreen: false,
                                    showFullScreenWithBucket: false,
                                });
                            }}
                        />
                    </Flex.Column>
                </FullScreenOverlay>
            )}

            {state.showFullScreenWithBucket && (
                <FullScreenOverlay
                    bucket={({ minimize, maximize, size }) => (
                        <ExampleBucket
                            title="test"
                            minimize={minimize}
                            maximize={maximize}
                            size={size}
                        />
                    )}
                >
                    <Flex.Column gap="large">
                        <h3>
                            This overlay is only a container so layout ís decided by
                            child components. This overlay also uses bucket
                        </h3>
                        <Button.Primary
                            label="Close"
                            onClick={() => {
                                setState({
                                    showModal: false,
                                    showFullScreen: false,
                                    showFullScreenWithBucket: false,
                                });
                            }}
                        />
                    </Flex.Column>
                </FullScreenOverlay>
            )}
        </>
    );
}
